import SupplierFormPopup from "./SupplierFormPopup";

export default function EditSupplierPopup({ isOpen, onClose, supplier, onUpdated, businessUnitId }) {
  return isOpen && supplier ? <SupplierFormPopup key={supplier.id} supplier={supplier} businessUnitId={businessUnitId} onClose={onClose} onSaved={onUpdated} /> : null;
}
